export const DocCache: { [key: string]: any } = {};
